import { getIsTwilioBasedCallProvider } from 'calling-internal-common/utils/isThirdPartyCallingPopoverInUse';
import http from 'hub-http/clients/apiClient';
import { PHONE_NUMBER_PROVIDER } from '../constants/PhoneNumberProvider';
import CallingProvider from 'calling-internal-common/call-provider/records/CallingProvider';

/**
 * Factory method to create a UserSettingsUpdateRequest from a CallingProviderRecord
 * @param record
 * @returns
 */
export const createUserSettingsUpdateRequest = provider => {
  if (getIsTwilioBasedCallProvider(new CallingProvider(provider))) {
    return {
      callingProvider: provider.name.toUpperCase()
    };
  }
  return {
    callingProvider: PHONE_NUMBER_PROVIDER.INTEGRATIONS_PLATFORM,
    integrationsPlatformAppId: provider.appId
  };
};
export const updateUserSettings = data => http.patch('calling-orchestration/v1/settings/user', {
  data
});